export const EmojiSad = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    fill="none"
    viewBox="0 0 64 64"
  >
    <g filter="url(#filter0_iif_5246_190098)">
      <path
        stroke="#050304"
        stroke-linecap="round"
        stroke-width="3.868"
        d="M3.483 10.927c-1.518-6.34 9.345-7.078 10.496-2.27 1.068 4.46-4.777 7.029-5.607 9.719-.83 2.69 0 2.983 0 2.983m0 5.743.085.358"
      />
    </g>
    <g filter="url(#filter1_f_5246_190098)">
      <ellipse cx="31.999" cy="61.074" fill="#C2DEE4" rx="23.515" ry="1.011" />
    </g>
    <mask
      id="mask0_5246_190098"
      width="42"
      height="42"
      x="11"
      y="9"
      maskUnits="userSpaceOnUse"
      style={{ maskType: "alpha" }}
    >
      <circle cx="31.957" cy="29.924" r="20.924" fill="#fff" />
    </mask>
    <g mask="url(#mask0_5246_190098)">
      <circle cx="31.957" cy="29.924" r="20.924" fill="#D9D9D9" />
      <circle
        cx="31.957"
        cy="29.924"
        r="20.924"
        fill="url(#paint0_radial_5246_190098)"
      />
      <circle
        cx="31.957"
        cy="29.924"
        r="20.924"
        fill="url(#paint1_linear_5246_190098)"
      />
      <g filter="url(#filter2_f_5246_190098)">
        <path
          fill="url(#paint2_linear_5246_190098)"
          d="M43.67 45.32c5.77-4.442 7.015-8.864 7.891-15.05-1.855 7.309-5.172 10.678-9.935 14.099-5.491 3.943-10.253 4.5-18.31 3.733 7.062 1.826 14.274 1.897 20.354-2.782Z"
        />
      </g>
      <g filter="url(#filter3_f_5246_190098)">
        <path
          fill="#0057D6"
          d="M50.858 35.953c-.714 0-1.413.268-2.095.804l-.316-1.454a4.95 4.95 0 0 1 1.255-.687 3.432 3.432 0 0 1 1.334-.249c.617 0 .96.115 1.35.368.4.236.707.574.945.952.238.379.4.805.487 1.278.098.458.147.9.147 1.325 0 .537-.07 1.018-.212 1.444-.14.41-.314.796-.52 1.159-.205.363-.241.43-.49.762-.25.331-.477.678-.682 1.041-.206.347-.38.734-.52 1.16-.141.41-.211.875-.211 1.395v.26c0 .095.005.182.016.261h-1.267a7.31 7.31 0 0 1-.066-.994c0-.505.06-.962.18-1.372.13-.41.292-.789.487-1.136.195-.363.4-.694.617-.994.217-.315.422-.63.617-.946a4.93 4.93 0 0 0 .471-.994c.13-.347.195-.725.195-1.136 0-.662-.146-1.198-.438-1.609-.293-.425-.72-.638-1.284-.638Zm.488 13.652c0 .426.438.797.243 1.112-.194.316-.46-.466-.796-.466-.335 0-.6.782-.796.466-.195-.315.313-.686.313-1.112 0-.426-.508-.796-.313-1.112.195-.315.46.394.796.394s.602-.71.796-.394c.195.316-.243.686-.243 1.112Z"
        />
      </g>
    </g>
    <g filter="url(#filter4_d_5246_190098)">
      <ellipse
        cx="41.981"
        cy="23.436"
        fill="url(#paint3_radial_5246_190098)"
        rx="7.804"
        ry="8.266"
        transform="rotate(20 41.981 23.436)"
      />
    </g>
    <ellipse
      cx="46.52"
      cy="27.896"
      fill="#fff"
      rx=".754"
      ry="1.914"
      transform="rotate(44.325 46.52 27.896)"
    />
    <ellipse
      cx="42.984"
      cy="30.117"
      fill="#fff"
      rx=".406"
      ry="1.031"
      transform="rotate(77.674 42.984 30.117)"
    />
    <g filter="url(#filter5_d_5246_190098)">
      <ellipse
        cx="21.659"
        cy="23.442"
        fill="url(#paint4_radial_5246_190098)"
        rx="7.804"
        ry="8.266"
        transform="rotate(-20 21.659 23.442)"
      />
    </g>
    <ellipse
      cx="28.002"
      cy="23.942"
      fill="#fff"
      rx=".754"
      ry="1.914"
      transform="rotate(4.326 28.002 23.942)"
    />
    <ellipse
      cx="26.721"
      cy="27.916"
      fill="#fff"
      rx=".406"
      ry="1.031"
      transform="rotate(37.674 26.72 27.916)"
    />
    <circle cx="42.498" cy="20" r="2" fill="#171A1C" />
    <circle cx="21.498" cy="26" r="2" fill="#171A1C" />
    <g filter="url(#filter6_ii_5246_190098)">
      <path
        stroke="#050304"
        stroke-linecap="round"
        stroke-width="2.242"
        d="M25.5 42.547s1.186-3.048 6.434-3.048 6.434 3.048 6.434 3.048"
      />
    </g>
    <g filter="url(#filter7_ii_5246_190098)">
      <path
        stroke="#050304"
        stroke-linecap="round"
        stroke-width="2.753"
        d="M50.144 38.334c1.314-4.203 5.49-1.16 4.493 2.027-.924 2.957-3.482 1.806-4.788 3.243-1.306 1.438-.885 2.831-.885 2.831m-.322 3.358-.075.238"
      />
    </g>
    <g filter="url(#filter8_ii_5246_190098)">
      <path
        stroke="#050304"
        stroke-linecap="round"
        stroke-width="2.753"
        d="M50.149 7.115c-.562-3.364 4.066-2.835 4.492-.283.395 2.367-2.161 2.53-2.674 4-.513 1.469.379 2.265.379 2.265m1.047 2.418.032.19"
      />
    </g>
    <defs>
      <filter
        id="filter0_iif_5246_190098"
        width="20.424"
        height="29.652"
        x="-.523"
        y="1.674"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="3.856" dy="1.928" />
        <feGaussianBlur stdDeviation="1.928" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.980392 0 0 0 0 0.333333 0 0 0 0 0.176471 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_5246_190098" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="-1.928" dy="-1.928" />
        <feGaussianBlur stdDeviation="1.928" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.341176 0 0 0 0 0.839216 0 0 0 1 0" />
        <feBlend
          in2="effect1_innerShadow_5246_190098"
          result="effect2_innerShadow_5246_190098"
        />
        <feGaussianBlur
          result="effect3_foregroundBlur_5246_190098"
          stdDeviation=".375"
        />
      </filter>
      <filter
        id="filter1_f_5246_190098"
        width="50.463"
        height="5.457"
        x="6.768"
        y="58.346"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5246_190098"
          stdDeviation=".858"
        />
      </filter>
      <filter
        id="filter2_f_5246_190098"
        width="32.536"
        height="23.276"
        x="21.171"
        y="28.128"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5246_190098"
          stdDeviation="1.073"
        />
      </filter>
      <filter
        id="filter3_f_5246_190098"
        width="11.526"
        height="22.43"
        x="45.443"
        y="31.363"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5246_190098"
          stdDeviation="1.502"
        />
      </filter>
      <filter
        id="filter4_d_5246_190098"
        width="29.244"
        height="29.949"
        x="28.862"
        y="10.712"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="1.502" dy="2.253" />
        <feGaussianBlur stdDeviation="3.38" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.970833 0 0 0 0 0.619202 0 0 0 0 0.533958 0 0 0 1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5246_190098"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_5246_190098"
          result="shape"
        />
      </filter>
      <filter
        id="filter5_d_5246_190098"
        width="29.244"
        height="29.949"
        x="8.539"
        y="10.72"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="1.502" dy="2.253" />
        <feGaussianBlur stdDeviation="3.38" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.972549 0 0 0 0 0.619608 0 0 0 0 0.533333 0 0 0 1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5246_190098"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_5246_190098"
          result="shape"
        />
      </filter>
      <filter
        id="filter6_ii_5246_190098"
        width="17.365"
        height="6.799"
        x="23.628"
        y="37.624"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="1.502" dy=".751" />
        <feGaussianBlur stdDeviation=".751" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.980392 0 0 0 0 0.333333 0 0 0 0 0.176471 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_5246_190098" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="-.751" dy="-.751" />
        <feGaussianBlur stdDeviation=".751" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.341176 0 0 0 0 0.839216 0 0 0 1 0" />
        <feBlend
          in2="effect1_innerShadow_5246_190098"
          result="effect2_innerShadow_5246_190098"
        />
      </filter>
      <filter
        id="filter7_ii_5246_190098"
        width="11.741"
        height="18.352"
        x="46.269"
        y="33.976"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="1.845" dy=".922" />
        <feGaussianBlur stdDeviation=".922" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.980392 0 0 0 0 0.333333 0 0 0 0 0.176471 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_5246_190098" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="-.922" dy="-.922" />
        <feGaussianBlur stdDeviation=".922" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.341176 0 0 0 0 0.839216 0 0 0 1 0" />
        <feBlend
          in2="effect1_innerShadow_5246_190098"
          result="effect2_innerShadow_5246_190098"
        />
      </filter>
      <filter
        id="filter8_ii_5246_190098"
        width="10.099"
        height="15.556"
        x="47.804"
        y="2.453"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="1.845" dy=".922" />
        <feGaussianBlur stdDeviation=".922" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.980392 0 0 0 0 0.333333 0 0 0 0 0.176471 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_5246_190098" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="-.922" dy="-.922" />
        <feGaussianBlur stdDeviation=".922" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.341176 0 0 0 0 0.839216 0 0 0 1 0" />
        <feBlend
          in2="effect1_innerShadow_5246_190098"
          result="effect2_innerShadow_5246_190098"
        />
      </filter>
      <radialGradient
        id="paint0_radial_5246_190098"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(22.56203 21.52868 -20.13218 21.0985 24.889 24.16)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEFFCF" />
        <stop offset=".418" stop-color="#FFCA42" />
        <stop offset=".736" stop-color="#FFCF53" />
        <stop offset="1" stop-color="#FF8163" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_5246_190098"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(47.426 -3.958 57.15) scale(10.4661 9.4336)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".443" stop-color="#fff" />
        <stop offset=".667" stop-color="#F0F9FF" />
        <stop offset=".833" stop-color="#D0EBFF" />
        <stop offset="1" stop-color="#F0F9FF" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_5246_190098"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(47.426 -14.125 34.02) scale(10.4661 9.4336)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".443" stop-color="#fff" />
        <stop offset=".667" stop-color="#F0F9FF" />
        <stop offset=".833" stop-color="#D0EBFF" />
        <stop offset="1" stop-color="#F0F9FF" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_5246_190098"
        x1="22.008"
        x2="34.941"
        y1="11.078"
        y2="29.377"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".075" stop-color="#FEFFCF" />
        <stop offset=".353" stop-color="#FEFFCF" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5246_190098"
        x1="43.397"
        x2="36.138"
        y1="45.394"
        y2="38.237"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FA552D" />
        <stop offset="1" stop-color="#FA552D" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
